import pricesService from 'services/prices.service'
import supplementsService from 'services/supplements.service'
import i18n from 'i18n'
import { useToast } from "vue-toastification"
const toast = useToast();

const state = {
    hotelId: null,
    hotels: [],
    markets: [],
    seasonTypes: [],
    currencies: [],
    spoList: [],
    spoTypes: [],
    spoSubTypes: [],
    meals: [],
    rooms: [],
    roomsPrices: {},
    accSupplements: [],
    accSupplementPrices: [],
    mealSupplements: [],
    mealSupplementPrices: [],
    kbTypes: [],
    removeSpoLoading: false,
    saveSpoLoading: false,
    accSupplementPricesLoading: false,
    loading: false,
    removeLoading: false,
    editContract: {},
    editDiscount: {},
    editRotation: {},
    removeSpoPriceContractLoading: false,
    removeSpoPriceDiscountLoading: false,
    saveSpoPriceDiscountLoading: false,
    saveSpoPriceRotationLoading: false,
    removeSpoPriceRotationLoading: false
}

const getters = {
    
}

const mutations = {
    setHotelId(state, hotelId = null) {
        state.hotelId = hotelId;
    },
    setHotels(state, hotels = []) {
        state.hotels = hotels;
    },
    setMarkets(state, markets = []) {
        state.markets = markets;
    },
    setSeasonTypes(state, types = []) {
        state.seasonTypes = types;
    },
    setAccSupplements(state, supplements = []) {
        state.accSupplements = supplements.map(item => ({
            value: item.id,
            label: item.name,
        }));
        state.accSupplements.unshift({ label: i18n.global.t('supplements.without_supplement'), value: null });
    },
    setMealSupplements(state, supplements = []) {
        state.mealSupplements = supplements.map(item => ({
            value: item.id,
            label: item.name,
        }));
        state.mealSupplements.unshift({ label: i18n.global.t('supplements.without_supplement'), value: null });
    },
    setAccSupplementPrices(state, prices = []) {
        state.accSupplementPrices = prices;
    },
    setMealSupplementPrices(state, prices = []) {
        state.mealSupplementPrices = prices;
    },
    setCurrencies(state, currencies = []) {
        state.currencies = currencies;
    },
    setSpoTypes(state, spoTypes = []) {
        state.spoTypes = spoTypes;
    },
    setSpoSubTypes(state, spoSubTypes = []) {
        state.spoSubTypes = spoSubTypes;
    },
    setMeals(state, meals = []) {
        meals.unshift({label: i18n.global.t('components.all'), value: null})
        state.meals = meals;
    },
    setRooms(state, rooms = []) {
        rooms.unshift({label: i18n.global.t('components.all'), value: null})
        state.rooms = rooms;
    },
    setRoomsPrices(state, roomsPrices = {}) {
        state.roomsPrices = {};
        state.roomsPrices = roomsPrices;
    },
    setKbTypes(state, kbTypes = []) {
        state.kbTypes = kbTypes;
    },
    setSpoList(state, spoList = []) {
        state.spoList = spoList;
    },
    setLoading(state, loading = false) {
        state.loading = loading;
    },
    setRemoveSpoLoading(state, loading = false) {
        state.removeSpoLoading = loading;
    },
    setSaveSpoLoading(state, loading = false) {
        state.saveSpoLoading = loading;
    },
    setSaveSpoPriceContractLoading(state, loading = false) {
        state.saveSpoPriceContractLoading = loading;
    },
    setAccSupplementPricesLoading(state, loading = false) {
        state.accSupplementPricesLoading = loading;
    },
    setMealSupplementPricesLoading(state, loading = false) {
        state.mealSupplementPricesLoading = loading;
    },
    setSpo(state, spo) {
        const index = state.spoList.findIndex(item => item.inc == spo.inc);
        if(index !== -1)
            state.spoList[index] = spo;
        else
            state.spoList.push(spo);
    },
    setSpoPrices(state, payload) {
        const spo = state.spoList.find(item => item.inc == payload.spo.inc);
        spo.showPrices = !spo.showPrices;
        spo.prices = payload.prices;
    },
    hideSpoPrices(state, spo) {
        state.spoList.find(item => item.inc == spo.inc).showPrices = false;
    },
    showSpoPrices(state, spo) {
        state.spoList.find(item => item.inc == spo.inc).showPrices = true;
    },
    setRemoveLoading(state, removeLoading = false) {
        state.removeLoading = removeLoading;
    },
    removeSpo(state, spo) {
        const index = state.spoList.findIndex(item => item.inc == spo.inc);
        state.spoList.splice(index, 1);
    },
    removeSpoPriceContract(state, payload) {
        const spo = state.spoList.find(item => item.inc == payload.spo.inc);
        const index = spo.prices.findIndex(item => item.inc == payload.contract.inc);
        spo.prices.splice(index, 1);
    },
    setEditContract(state, contract) {
        state.editContract = contract;
    },
    setEditDiscount(state, discount) {
        state.editDiscount = discount;
    },
    setEditRotation(state, rotation) {
        state.editRotation = rotation;
    },
    setRemoveSpoPriceContractLoading(state, loading = false) {
        state.removeSpoPriceContractLoading = loading;
    },
    setRemoveSpoPriceDiscountLoading(state, loading = false) {
        state.removeSpoPriceDiscountLoading = loading;
    },
    setRemoveSpoPriceRotationLoading(state, loading = false) {
        state.removeSpoPriceRotationLoading = loading;
    },
    removeSpoPriceDiscount(state, payload) {
        const spo = state.spoList.find(item => item.inc == payload.spo.inc);
        const index = spo.prices.findIndex(item => item.inc == payload.discount.inc);
        spo.prices.splice(index, 1);
    },
    removeSpoPriceRotation(state, payload) {
        const spo = state.spoList.find(item => item.inc == payload.spo.inc);
        const index = spo.prices.findIndex(item => item.inc == payload.rotation.inc);
        spo.prices.splice(index, 1);
    },
    setSaveSpoPriceDiscountLoading(state, loading = false) {
        state.saveSpoPriceDiscountLoading = loading;
    },
    setSaveSpoPriceRotationLoading(state, loading = false) {
        state.saveSpoPriceRotationLoading = loading;
    }
}

const actions = {
    getMeals({ commit }, params) {
        pricesService.getMeals(params).then(meals => {
            commit('setMeals', meals);
        })
    },
    getRooms({ commit }, params) {
        pricesService.getRooms(params).then(rooms => {
            commit('setRooms', rooms);
        })
    },
    getKbTypes({ commit }) {
        pricesService.getKbTypes().then(kbTypes => {
            console.log(kbTypes)
            commit('setKbTypes', kbTypes);
        })
    },
    getAccSupplements({ commit }, params) {
        return new Promise((resolve, reject) => {
            supplementsService.getAccSupplements(params).then(supplements => {
                commit('setAccSupplements', supplements);
                resolve(supplements);
            })
        });
    },
    getMealSupplements({ commit }, params) {
        return new Promise((resolve, reject) => {
            supplementsService.getMealSupplements(params).then(supplements => {
                commit('setMealSupplements', supplements);
                resolve(supplements);
            })
        });
    },
    getAccSupplementPrices({ commit }, params) {
        commit('setAccSupplementPricesLoading', true);
        commit('setAccSupplementPrices', []);
        return new Promise((resolve, reject) => {
            supplementsService.getAccSupplementPrices(params).then(data => {
                commit('setAccSupplementPrices', data);
                commit('setAccSupplementPricesLoading', false);
                resolve(data);
            });
        });
    },
    getMealSupplementPrices({ commit }, params) {
        commit('setMealSupplementPricesLoading', true);
        commit('setMealSupplementPrices', []);
        return new Promise((resolve, reject) => {
            supplementsService.getMealSupplementPrices(params).then(data => {
                commit('setMealSupplementPrices', data);
                commit('setMealSupplementPricesLoading', false);
                resolve(data);
            });
        });
    },
    getHotels({ commit }) {
        pricesService.getHotels().then(response => {
            commit('setHotels', response);
        })
    },
    getMarkets({ commit }) {
        pricesService.getMarkets().then(response => {
            commit('setMarkets', response);
        })
    },
    getRoomsPrices({ commit }, params) {
        commit('setRoomsPrices', {});
        pricesService.getRoomsPrices(params).then(response => {
            commit('setRoomsPrices', response);
        })
    },
    getSeasonTypes({ commit }, params) {
        pricesService.getSeasonTypes(params).then(response => {
            commit('setSeasonTypes', response);
        })
    },
    getCurrencies({ commit }) {
        pricesService.getCurrencies().then(response => {
            commit('setCurrencies', response);
        })
    },
    getSpoList({ commit }, params) {
        commit('setLoading', true);
        pricesService.getSpoList(params).then(response => {
            commit('setLoading', false);
            commit('setSpoList', response);
        }).catch(() => {
            commit('setLoading', false);
        })
    },
    getSpoPrices({ commit }, spo) {
        return new Promise((resolve, reject) => {
            if(spo.showPrices && !spo.notHidePrices) {
                resolve();
                commit('hideSpoPrices', spo);
                return;
            }
            pricesService.getSpoPrices({spo_id: spo.inc, hotel_id: spo.hotelId}).then(prices => {
                resolve(prices);
                commit('setSpoPrices', {spo: spo, prices: prices});
                commit('showSpoPrices', spo);
            }).catch(() => {
                reject();
            })
        });
    },
    
    getSpoTypes({ commit }) {
        pricesService.getSpoTypes().then(spoTypes => {
            commit('setSpoTypes', spoTypes);
        })
    },
    getSpoSubTypes({ commit }) {
        pricesService.getSpoSubTypes().then(spoSubTypes => {
            commit('setSpoSubTypes', spoSubTypes);
        })
    },
    saveSpo({ commit }, payload) {
        commit('setSaveSpoLoading', true);
        return new Promise((resolve, reject) => {
            pricesService.saveSpo(payload.spo).then((response) => {
                payload.spo.inc = response[0].inc;
                payload.spo.Number = response[0].number;
                payload.spo.spostypelist = payload.spo.spostypelist.split(',');
                payload.spo.kbtypelist = payload.spo.kbtypelist.split(',');
                commit('setSpo', payload.spo);
                commit('setSaveSpoLoading', false);
                resolve(response);
            }).catch(() => {
                commit('setSaveSpoLoading', false);
                reject();
            })
        });
    },
    removeSpo({ commit }, spo) {
        commit('setRemoveLoading', true);
        return new Promise((resolve, reject) => {
            pricesService.getSpoPrices({spo_id: spo.inc, hotel_id: spo.hotelId}).then(prices => {
                if(prices.length){
                    toast.error(i18n.global.t('prices.spo_prices_not_empty'));
                    commit('setRemoveLoading', false);
                    reject();
                }else{
                    pricesService.removeSpo({spo_id: spo.inc}).then(() => {
                        commit('setRemoveLoading', false);
                        commit('removeSpo', spo);
                        resolve();
                    }).catch(() => {
                        commit('setRemoveLoading', false);
                        reject();
                    })
                }
            }).catch(() => {
                reject();
            })
        });
        
    },
    saveSpoPriceContract({ commit }, contract) {
        commit('setSaveSpoPriceContractLoading', true);

        return new Promise((resolve, reject) => {
            pricesService.saveSpoPriceContract(contract).then((response) => {
                commit('setSaveSpoPriceContractLoading', false);
                resolve(response);
            }).catch(() => {
                commit('setSaveSpoPriceContractLoading', false);
                reject();
            })
        });
    },
    getContract({ commit }, contract) {
        return new Promise((resolve, reject) => {
            pricesService.getContract(contract).then((response) => {
                commit('setEditContract', response);
                resolve(response);
            }).catch(() => {
                reject();
            })
        });
    },
    getDiscount({ commit }, discount) {
        return new Promise((resolve, reject) => {
            pricesService.getDiscount(discount).then((response) => {
                commit('setEditDiscount', response);
                resolve(response);
            }).catch(() => {
                reject();
            })
        });
    },
    getRotation({ commit }, rotation) {
        return new Promise((resolve, reject) => {
            pricesService.getRotation(rotation).then((response) => {
                commit('setEditRotation', response);
                resolve(response);
            }).catch(() => {
                reject();
            })
        });
    },
    removeSpoPriceContract({ commit }, payload) {
        commit('setRemoveSpoPriceContractLoading', true);
        return new Promise((resolve, reject) => {
            pricesService.removeSpoPriceContract({contract_id: payload.contract.inc}).then(() => {
                commit('setRemoveSpoPriceContractLoading', false);
                commit('removeSpoPriceContract', payload);
                resolve();
            }).catch(() => {
                commit('setRemoveSpoPriceContractLoading', false);
                reject();
            })
        });
    },
    removeSpoPriceDiscount({ commit }, payload) {
        commit('setRemoveSpoPriceDiscountLoading', true);
        return new Promise((resolve, reject) => {
            pricesService.removeSpoPriceDiscount({discount_id: payload.discount.inc}).then(() => {
                commit('setRemoveSpoPriceDiscountLoading', false);
                commit('removeSpoPriceDiscount', payload);
                resolve();
            }).catch(() => {
                commit('setRemoveSpoPriceDiscountLoading', false);
                reject();
            })
        });
    },
    saveSpoPriceDiscount({ commit }, discount) {
        commit('setSaveSpoPriceDiscountLoading', true);

        return new Promise((resolve, reject) => {
            pricesService.saveSpoPriceDiscount(discount).then((response) => {
                commit('setSaveSpoPriceDiscountLoading', false);
                resolve(response);
            }).catch(() => {
                commit('setSaveSpoPriceDiscountLoading', false);
                reject();
            })
        });
    },
    removeSpoPriceRotation({ commit }, payload) {
        commit('setRemoveSpoPriceRotationLoading', true);
        return new Promise((resolve, reject) => {
            pricesService.removeSpoPriceRotation({rotation_id: payload.rotation.inc}).then(() => {
                commit('setRemoveSpoPriceRotationLoading', false);
                commit('removeSpoPriceRotation', payload);
                resolve();
            }).catch(() => {
                commit('setRemoveSpoPriceRotationLoading', false);
                reject();
            })
        });
    },
    saveSpoPriceRotation({ commit }, rotation) {
        commit('setSaveSpoPriceRotationLoading', true);

        return new Promise((resolve, reject) => {
            pricesService.saveSpoPriceRotation(rotation).then((response) => {
                commit('setSaveSpoPriceRotationLoading', false);
                resolve(response);
            }).catch(() => {
                commit('setSaveSpoPriceRotationLoading', false);
                reject();
            })
        });
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
